var randBool = require('./randBool');

    /**
     * Returns random sign (-1 or 1)
     */
    function randomSign() {
        return randBool()? 1 : -1;
    }

    module.exports = randomSign;




//////////////////
// WEBPACK FOOTER
// ./~/mout/random/randSign.js
// module id = 1658
// module chunks = 0 1 2